// import TravelportPcc from '../Models/TravelPortPccModal';
import { NgbModal, NgbModalRef, ModalDismissReasons, NgbModalOptions, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TravelportPccService } from './travelport-pcc.service';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-travelport-pcc',
  templateUrl: './travelport-pcc.component.html',
  styleUrls: ['./travelport-pcc.component.css']
})
export class TravelportPccComponent implements OnInit {

  pccList = [];

  model: any = {};

  isEditMode = false;
  constructor(
    private service: TravelportPccService,
    private modalService: NgbModal
  ) { }
  @ViewChild('pccModal', { static: false })
  pccModal: TemplateRef<any>;
  modalRef: NgbModalRef;
  ngOnInit() {
    this.loadData();
  }

  loadData() {

    this.service.getAll()
      .subscribe((res: any) => {

        this.pccList = res.data;

      });

  }

  save() {

    if (this.isEditMode) {

      this.service.update(this.model)
        .subscribe(() => {

          this.loadData();
          this.modalRef.close();

          this.isEditMode = false;

        });

    }
    else {

      this.service.create(this.model)
        .subscribe(() => {

          this.loadData();
          this.modalRef.close();
          this.model = {};
        });

    }

  }
  openModal() {

    if (!this.isEditMode) {
      this.model = {};
    }

    this.modalRef = this.modalService.open(
      this.pccModal,
      {
        size: 'lg',
        backdrop: 'static'
      }
    );
  }
  addNew() {

    this.isEditMode = false;

    this.model = {};

    this.openModal();
  }
  edit(item) {

    this.model = { ...item };

    this.isEditMode = true;

    this.openModal();

  }

  delete(id: number) {

    if (!confirm('Delete this PCC?')) {
      return;
    }

    this.service.delete(id)
      .subscribe(() => {

        this.loadData();

      });

  }

  changeStatus(item) {

    const previousValue = !item.isActive;

    this.service.changeStatus(
      item.id,
      item.isActive
    )
      .subscribe(
        () => {

        },
        () => {

          item.isActive = previousValue;

        }
      );
  }

}
